export default function Gallery() {
  return (
    <section className="py-24 bg-black">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl md:text-5xl font-serif text-white mb-4">
            優雅なる情景
          </h3>
          <p className="text-gray-400 text-base">The Azalea Tokyoの世界</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="w-full h-[500px]">
            <img
              src="/demo/hotel-site/images/gallery-main.png"
              alt="Gallery Image"
              className="w-full h-full object-cover hover:opacity-90 transition-opacity cursor-pointer"
            />
          </div>
          <div className="grid grid-cols-1 gap-4">
            <div className="w-full h-[242px]">
              <img
                src="/demo/hotel-site/images/gallery-bar.png"
                alt="Gallery Image"
                className="w-full h-full object-cover hover:opacity-90 transition-opacity cursor-pointer"
              />
            </div>
            <div className="w-full h-[242px]">
              <img
                src="/demo/hotel-site/images/gallery-bathroom.png"
                alt="Gallery Image"
                className="w-full h-full object-cover hover:opacity-90 transition-opacity cursor-pointer"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}